/**
 * @param {{
 *   CustomizeHomepageServiceV2: ReturnType<import('../../../services/v2/CustomizeHomepageServiceV2').default>,
 * }} param0
 */
export default function customizeHomepageUseCaseV2({ CustomizeHomepageServiceV2 }) {
  const create = (payload) => {
    if (!payload) {
      throw new Error('Missing payload');
    }
    if (!payload.sectionType) {
      throw new Error('Missing sectionType in payload');
    }
    return CustomizeHomepageServiceV2.create(payload);
  };

  const get = () => {
    return CustomizeHomepageServiceV2.get();
  };

  const deleteSection = (sectionId) => {
    if (!sectionId) {
      throw new Error('Missing sectionId');
    }
    return CustomizeHomepageServiceV2.deleteSection(sectionId);
  };

  const sortSections = (sectionIds) => {
    if (!sectionIds || !Array.isArray(sectionIds)) {
      throw new Error('Missing or invalid sectionIds array');
    }
    if (sectionIds.length === 0) {
      throw new Error('Section IDs array cannot be empty');
    }
    return CustomizeHomepageServiceV2.sortSections(sectionIds);
  };

  const updateSectionActiveState = (sectionId, isActive) => {
    if (!sectionId) {
      throw new Error('Missing sectionId');
    }
    if (typeof isActive !== 'boolean') {
      throw new Error('isActive must be a boolean value');
    }
    return CustomizeHomepageServiceV2.updateSectionActiveState(sectionId, isActive);
  };

  const updateSection = (sectionId, payload) => {
    if (!sectionId) {
      throw new Error('Missing sectionId');
    }
    if (!payload) {
      throw new Error('Missing payload');
    }
    if (!payload.sectionType) {
      throw new Error('Missing sectionType in payload');
    }
    return CustomizeHomepageServiceV2.updateSection(sectionId, payload);
  };

  return {
    create,
    get,
    deleteSection,
    sortSections,
    updateSectionActiveState,
    updateSection,
  };
}
